<template>
  <Html :lang="locale">
    <HeadBase />
    <v-app>
      <v-locale-provider :locale :rtl>
        <nuxt-loading-indicator />
        <NavBar />
        <AnnouncementStrip v-if="announcement" :announcement />
        <v-main>
          <nuxt-page />
        </v-main>
        <TheFooter />
        <Snackbar ref="snackbar" />
        <DevToolkit />
      </v-locale-provider>
    </v-app>
  </Html>
</template>

<script setup lang="ts">
import { snackbarInjectionKey } from '~/assets/injection-keys';
import { Snackbar } from '#components';

const { locale, rtl } = useLocalization();
const { announcement } = useBranch();

useSchemaOrg('global');

const snackbar = ref<InstanceType<typeof Snackbar> | null>(null);
provide(snackbarInjectionKey, snackbar);
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>